import { StoreLinks } from '../../scripts/storeLinks.mjs'
import type { StoreSlot } from '../../scripts/storeLinks.mjs'

/**
 * Maps the map-surface page a visitor is on to the attribution slot its
 * store CTA should be credited to.
 *
 * The prerendered badges on route / station / line pages are read by
 * crawlers only: the map clips the static `<main>` away with
 * `overflow: hidden` as soon as the SPA mounts, so a person never sees
 * them (TASK-814). The CTA a person can actually tap therefore lives on
 * the map, and it has to carry the slot of the page it is shown on, or
 * every install from the site lands in one column and the per-surface
 * comparison the slot registry exists for is lost.
 *
 * URL-only by design, same reasoning as {@link installBannerDeepLink}:
 * the component mounts above the schema provider, so there is no slug
 * set to validate against — and none is needed, since only the surface
 * kind matters here, never the specific station.
 *
 * The station DETAIL route (`/station/<ref>`) is deliberately absent: it
 * is not a map surface. It renders its own page with a visible header
 * CTA and promo badges, both already tagged `web-station-page`.
 */
export function mapCtaSlot(pathname: string): StoreSlot {
  const [, kind] = pathname.split('/').filter((segment) => segment !== '')
  switch (kind) {
    case 'stations':
      return StoreLinks.SLOTS.STATION_PAGE
    case 'lines':
      return StoreLinks.SLOTS.LINE_PAGE
    case 'routes':
    case 'route':
      return StoreLinks.SLOTS.ROUTE_PAGE
    default:
      return StoreLinks.SLOTS.HOME_CTA
  }
}
